import style from "../style/screens/PublicPage.module.css";

const Support = () => (
    <main className={style["page"]}>
        <section className={style["card"]}>
            <p className={style["eyebrow"]}>모두해요 고객지원</p>
            <h1>무엇을 도와드릴까요?</h1>
            <p>
                앱 이용, 수거 키오스크 상태, 포인트 내역 또는 계정에 관한 문의를 이메일로 보내주세요.
                문의 내용과 함께 문제가 발생한 시간, 수거 키오스크 이름을 알려주시면 더 빠르게 확인할 수 있습니다.
            </p>
            <a className={style["primary-link"]} href="mailto:support@innaim.com">
                support@innaim.com
            </a>
            <dl>
                <div>
                    <dt>운영자</dt>
                    <dd>주식회사 인네임</dd>
                </div>
                <div>
                    <dt>서비스</dt>
                    <dd>모두해요</dd>
                </div>
                <div>
                    <dt>지원 언어</dt>
                    <dd>한국어</dd>
                </div>
            </dl>
            <nav className={style["links"]} aria-label="정책 링크">
                <a href="/privacy-policy">개인정보처리방침</a>
                <a href="/terms-of-service">이용약관</a>
                <a href="/delete">계정 삭제 안내</a>
            </nav>
        </section>
    </main>
);

export default Support;
